import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import SubfoldersIcon from '../../../Icons/24x24/Subfolders';
import FolderSyncIndicator from '../FolderSyncIndicator';
import { IconSize } from '../../../Icons/IconWrap';
import UnwatchIcon from '../../../Icons/Unwatch';
import FolderCoverInfo from '../../../FolderCoverInfo';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import GallectionCoverDumbo from '../../../GallectionCoverDumbo';
import folderCardStyles from '../../FolderCard.scss';
var FolderCardContent = function (_a) {
    var className = _a.className, folder = _a.folder, _b = _a.folder, isPortfolioLinked = _b.isPortfolioLinked, subfolders = _b.subfolders, _c = _b.hasSubfolders, hasSubfoldersFromFolder = _c === void 0 ? !!(subfolders === null || subfolders === void 0 ? void 0 : subfolders.length) : _c, type = _b.type, totalDeviationCount = _a.totalDeviationCount, hasSubfoldersOverride = _a.hasSubfolders, isCurrentUserOwner = _a.isCurrentUserOwner, width = _a.width, height = _a.height;
    var t = useTranslation().t;
    var emptyGallectionInfo = {
        gallery: 'folderCard.empty.gallery.info',
        collection: 'folderCard.empty.collection.info',
    };
    var hasSubfolders = hasSubfoldersOverride !== null && hasSubfoldersOverride !== void 0 ? hasSubfoldersOverride : hasSubfoldersFromFolder;
    var showPortfolioSync = isPortfolioLinked && isCurrentUserOwner;
    if (!width || !height) {
        return null;
    }
    if (totalDeviationCount === 0 && isCurrentUserOwner) {
        return (React.createElement("div", { className: folderCardStyles['empty-folder'], style: { width: width, height: height } },
            React.createElement(UnwatchIcon, { className: folderCardStyles['empty-icon'], size: IconSize.HUGE }),
            React.createElement("div", { className: folderCardStyles['empty-folder-info'] }, t(emptyGallectionInfo[type]))));
    }
    var showOwnerPremiumInfo = isCurrentUserOwner &&
        normalizePremiumFolderData(folder.premiumFolderData).isPremium;
    // Only force blur if there's no gallection thumb, in which case we will use
    // the first deviation image from the gallection
    var forceBlur = showOwnerPremiumInfo && !folder.thumb;
    return (React.createElement("div", { className: className },
        (hasSubfolders || showPortfolioSync) && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: folderCardStyles['subfolders-icon-underlay'] }),
            React.createElement("div", { className: folderCardStyles['top-right-icons'] },
                showPortfolioSync && React.createElement(FolderSyncIndicator, null),
                hasSubfolders && (React.createElement(SubfoldersIcon, { className: classnames(folderCardStyles['subfolders-icon'], folderCardStyles['wix-portfolio-sync-feature']) }))))),
        React.createElement(GallectionCoverDumbo, { width: width, height: height, gallection: folder, forceBlur: forceBlur }),
        showOwnerPremiumInfo && (React.createElement("div", { className: folderCardStyles['top-right-icons'] },
            React.createElement(FolderCoverInfo, null)))));
};
export default FolderCardContent;
//# sourceMappingURL=FolderCardContent.js.map